/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedTime } from 'react-intl';

import { TranslatedCopy } from '../intl/TranslatedCopy';

export default [
  {
    header: <TranslatedCopy id='notifications.outage.type' />,
    id: 'notificationType',
    cell: ({ notificationType }) => {
      const type = /SAP/.test(notificationType) ? 'PLANNED_SAP_OUTAGE' : 'PLANNED_GD_OUTAGE';
      return (
        <div>
          <TranslatedCopy id={`notifications.options.${type}`} />
        </div>
      );
    }
  },
  {
    header: <TranslatedCopy id='notifications.outage.start' />,
    id: 'outageStart',
    cell: ({ outageStart }) => (
      <FormattedTime
        value={outageStart}
        year='2-digit'
        month='numeric'
        day='numeric'
        timeZone='America/Los_Angeles'
        timeZoneName='short'
      />
    )
  },
  {
    header: <TranslatedCopy id='notifications.outage.end' />,
    id: 'outageEnd',
    cell: ({ outageEnd }) => (
      <FormattedTime
        value={outageEnd}
        year='2-digit'
        month='numeric'
        day='numeric'
        timeZone='America/Los_Angeles'
        timeZoneName='short'
      />
    )
  },
  {
    header: <TranslatedCopy id='notifications.outage.status.title' />,
    id: 'outageStatus',
    cell: ({ notificationType }) => {
      const status = /UPCOMING/.test(notificationType) ? 'upcoming' : 'current';
      return (
        <div>
          <TranslatedCopy id={`notifications.outage.status.${status}`} />
        </div>
      );
    }
  }
];
